import i18next from 'i18next';

i18next.addResources('es_CL', 'EmptyOrders', {
  title: 'Actualmente sin pedidos'
});

i18next.addResources('es_CR', 'EmptyOrders', {
  title: 'Actualmente sin pedidos'
});
